module.exports = __webpack_public_path__ + "static/img/11.5135096.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/11.png
// module id = BCBu
// module chunks = 0